import { render } from "./moduli.vue?vue&type=template&id=454e3429&scoped=true"
import script from "./moduli.vue?vue&type=script&lang=js"
export * from "./moduli.vue?vue&type=script&lang=js"

import "./moduli.vue?vue&type=style&index=0&id=454e3429&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454e3429"]])

export default __exports__